/* Printverse3D — minimal theme JS (no dependencies) */
(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mnav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      document.body.classList.toggle('nav-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- product gallery ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gallery-thumb]');
      if (!btn || !mainImg) return;
      mainImg.src = btn.dataset.full;
      mainImg.srcset = '';
      mainImg.alt = btn.dataset.alt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.classList.toggle('active', b === btn);
      });
    });
  }

  /* ---------- variant picker ---------- */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;
    var priceEl = document.querySelector('[data-variant-price]');
    var compareEl = document.querySelector('[data-variant-compare]');
    var submit = form.querySelector('[data-add-button]');
    var data = {};
    try { data = JSON.parse(form.querySelector('[data-variant-json]').textContent); } catch (err) { data = {}; }

    function update() {
      var v = data[select.value];
      if (!v) return;
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) compareEl.innerHTML = v.compare || '';
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSold;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    }
    select.addEventListener('change', update);
    update();
  });

  /* ---------- cart quantity auto-submit ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.form.submit(); }, 200);
    });
  });

  /* ---------- collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
